"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Loader = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const icons_1 = require("@icr-ui/icons");
const theme_1 = require("@icr-ui/theme");
const flexbox_1 = require("../flexbox");
const styles_1 = require("./styles");
const Loader = ({ isLoading = false, boxed = false, standalone = false, withSuccess = false, color, size = '72px', checkmarkIconSize = 24, }) => {
    const SpinnerIconComponent = () => ((0, jsx_runtime_1.jsx)(icons_1.SpinnerIcon, { color: color, width: size, height: size }));
    const Spinner = () => ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: isLoading ? ((0, jsx_runtime_1.jsx)(SpinnerIconComponent, {})) : ((0, jsx_runtime_1.jsx)(styles_1.StyledCheckmarkIcon, { ...{ size }, children: (0, jsx_runtime_1.jsx)(icons_1.CheckmarkIcon, { width: checkmarkIconSize, height: checkmarkIconSize, color: theme_1.grayScale[50] }) })) }));
    if (standalone) {
        return (0, jsx_runtime_1.jsx)(SpinnerIconComponent, {});
    }
    if (boxed) {
        return ((0, jsx_runtime_1.jsx)(flexbox_1.Flexbox, { "data-testid": "loader", fullHeight: true, fullWidth: true, justifyContent: "center", alignItems: "center", children: (0, jsx_runtime_1.jsx)(SpinnerIconComponent, {}) }));
    }
    if (withSuccess) {
        return (0, jsx_runtime_1.jsx)(Spinner, {});
    }
    return ((0, jsx_runtime_1.jsx)(flexbox_1.Flexbox, { fullScreen: true, justifyContent: "center", customStyles: {
            position: 'absolute',
            zIndex: 9999,
            background: 'rgba(255,255,255,0.5)',
            top: 0,
            left: 0,
        }, "data-testid": "loader", children: (0, jsx_runtime_1.jsx)(SpinnerIconComponent, {}) }));
};
exports.Loader = Loader;
exports.default = exports.Loader;
//# sourceMappingURL=index.js.map